import { TranslationMap } from '@trimble-gcs/i18n-types';

export function permissionsTranslations() {
  return {
    defaultRole: {
      title: {
        text: $localize`:@@config.permissions.defaultRole.title:Default access for project members`,
        desc: 'Title for the default user permission assignment.',
      },
      adminRoleNote: {
        text: $localize`:@@config.permissions.defaultRole.adminRoleNote:('Admin' users always have full access.)`,
        desc: 'Information message that admin users always have full permissions.',
      },
    },
    roles: {
      admin: {
        text: $localize`:@@config.permissions.roles.admin:Admin`,
        desc: "'Admin' role name.",
      },
      fullaccess: {
        text: $localize`:@@config.permissions.roles.fullaccess:Full Access`,
        desc: "'Full Access' role name.",
      },
      readonly: {
        text: $localize`:@@config.permissions.roles.readonly:Read Only`,
        desc: "'Read Only' role name.",
      },
      noaccess: {
        text: $localize`:@@config.permissions.roles.noaccess:No Access`,
        desc: "'No Access' role name.",
      },
      none: {
        text: $localize`:@@config.permissions.roles.none:-- Not Set --`,
        desc: 'Displayed value when no role is selected.',
      },
    },
    groups: {
      title: {
        text: $localize`:@@config.permissions.groups.title:Access for specific project groups`,
        desc: 'Title for the list of group permission assignments.',
      },
      users: {
        '=0': {
          text: $localize`:@@config.permissions.groups.users.none:no users`,
          desc: 'Message displayed when there are no users in the group.',
        },
        '=1': {
          text: $localize`:@@config.permissions.groups.users.one:1 user`,
          desc: 'Message displayed when there is one user in the group.',
        },
        other: {
          text: $localize`:@@config.permissions.groups.users.other:{count} users`,
          desc: 'Message displayed when there are multiple users in the group.',
        },
      },
      role: {
        tooltip: {
          text: $localize`:@@config.permissions.groups.role.tooltip:Group Role`,
          desc: 'Tooltip for the group role assignment dropdown.',
        },
      },
      noGroups: {
        text: $localize`:@@config.permissions.groups.noGroups:No groups found.`,
        desc: 'Message displayed when no groups are available for permission assignment.',
      },
    },
    users: {
      title: {
        text: $localize`:@@config.permissions.users.title:Access for specific project members`,
        desc: 'Title for the add user role assignment section.',
      },
      add: {
        placeholder: {
          text: $localize`:@@config.permissions.users.add.placeholder:Begin typing to search...`,
          desc: 'Placeholder for the add user input.',
        },
      },
      role: {
        tooltip: {
          text: $localize`:@@config.permissions.users.role.tooltip:Member Role`,
          desc: 'Tooltip for the user role assignment dropdown.',
        },
      },
      remove: {
        tooltip: {
          text: $localize`:@@config.permissions.users.remove.tooltip:Remove Member Role Assignment`,
          desc: 'Tooltip for the remove user role assignment button.',
        },
      },
      status: {
        removed: {
          text: $localize`:@@config.permissions.users.status.removed:Removed`,
          desc: 'Text displayed for users who have been removed from the project.',
        },
      },
    },
    effectiveMemberRoles: {
      title: {
        text: $localize`:@@config.permissions.effectiveMemberRoles.title:Effective project member roles`,
        desc: 'Title for the readonly list of project members with their effective roles.',
      },
    },
    errors: {
      load: {
        text: $localize`:@@config.permissions.errors.load:Error loading permissions.`,
        desc: 'Error message when loading project permissions fails.',
      },
      save: {
        text: $localize`:@@config.permissions.errors.save:Error saving permissions.`,
        desc: 'Error message when saving project permissions fails.',
      },
    },
  } satisfies TranslationMap;
}
